import {SmallGreyButton} from "../../../../misc/SmallGreyButton";
import {useState} from "react";
import {Comment} from "@mui/icons-material";
import {Button, DialogActions, DialogContent, DialogTitle, TextField} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";

export function KeyingNotes(props: {
    value: string;
}) {
    const [show, setShow] = useState(false);

    return (
        <>
            <SmallGreyButton startIcon={<Comment color={props.value ? "primary" as "primary" : undefined} />} onClick={() => setShow(true)}>Quote Notes</SmallGreyButton>
            {show && <KeyingNotesModal value={props.value} onClose={() => setShow(false)} />}
        </>
    )
}

export function KeyingNotesModal(props: {
    onClose: () => void;
    value: string;
}) {

    return (
        <Dialog2 open onClose={props.onClose} fullWidth maxWidth="sm">
            <DialogTitle>
                Quote Notes
            </DialogTitle>
            <DialogContent>
                <TextField
                    multiline minRows={4}
                    fullWidth
                    value={props.value}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose}>Close</Button>
            </DialogActions>
        </Dialog2>
    )
}